import clsx from 'clsx';
import styles from './toggle.module.scss';

interface ToggleProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  /** Required: the track has no text, so this is its only accessible name. */
  label: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Hand-rolled rather than wrapping antd Switch: its geometry tokens are global,
 * so resizing to the mockup's 42x24 track would move the three existing Switch
 * call sites too. Fully controlled, so it cannot drift from its parent.
 */
export default function Toggle({ checked, onChange, label, disabled, className }: ToggleProps) {
  return (
    <button
      aria-checked={checked}
      aria-label={label}
      className={clsx(styles.toggle, checked && styles['toggle-on'], className)}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      role="switch"
      type="button"
    />
  );
}
